<div
  class="scroll vi-primary vi-hue-1 print-content no-print-flexbox truespeed-content internal"
  #pdfPage
  *ngIf="!loading"
>
  <div layout="column" class="page">
    <div class="page-break"></div>

    <div class="report-header">
      <img src="{{ logoUrl }}" class="truespeed-logo" />
      <h2 class="truespeed-title">{{ reportTitle }}</h2>
    </div>

    <hr />
    <div class="margin-10-left">
      <div style="margin-top: 10px; line-height: 1.6">
        <div class="header-style">
          <div class="header-class">Test Name</div>
          <div class="value-font">
            {{ testName }}
          </div>
        </div>
        <div class="header-style">
          <div class="header-class">Start Date</div>
          <div class="value-font">{{ startDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">End Date</div>
          <div class="value-font">{{ stopDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">Duration</div>
          <div class="value-font">{{ duration }}</div>
        </div>
        <div class="header-style" *ngIf="overallConfiguration">
          <div class="header-class">Test Points</div>
          <div class="value-font">
            {{ overallConfiguration.agent.primary.id }}
          </div>
        </div>
        <div
          class="header-style"
          *ngIf="
            overallConfiguration &&
            overallConfiguration.agent.secondary &&
            overallConfiguration.agent.secondary.length > 0
          "
        >
          <div class="header-class"></div>
          <div
            class="value-font"
            *ngIf="
              overallConfiguration &&
              overallConfiguration.agent.secondary &&
              overallConfiguration.agent.secondary.length > 0
            "
          >
            {{ overallConfiguration.agent.secondary[0].id }}
          </div>
        </div>
      </div>
      <div style="margin-top: 10px; line-height: 1.6">
        <div class="header-style" *ngIf="requestInfo.mode === 'CLIENT-TO-MA' && requestInfo.dmzUrl">
          <div class="header-class">DMZ Test URL</div>
          <div class="value-font">
            {{ requestInfo.dmzUrl }}
          </div>
        </div>
        <div
          class="header-style"
          *ngIf="
            requestInfo.mode === 'CLIENT-TO-MA' && requestInfo.vtaTsUrl && overallConfiguration
          "
        >
          <div class="header-class">{{ getAgentURLLabel() }}</div>
          <div class="value-font">
            {{ requestInfo.vtaTsUrl }}
          </div>
        </div>
      </div>
      <div
        *ngIf="
          (requestInfo?.customerInfo?.name ||
            requestInfo?.customerInfo?.contact ||
            requestInfo?.customerInfo?.phone ||
            requestInfo?.customerInfo?.email)
        "
      >
        <div class="reports-customer-info">
          <div class="info-title">Customer</div>
          <div class="info-container">
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.name">
              <div class="sec-header">Name</div>
              <div class="sec-value">{{ requestInfo.customerInfo.name }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.contact">
              <div class="sec-header">Contact</div>
              <div class="sec-value">{{ requestInfo.customerInfo.contact }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.email">
              <div class="sec-header">Email</div>
              <div class="sec-value">{{ requestInfo.customerInfo.email }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.phone">
              <div class="sec-header">Phone</div>
              <div class="sec-value">{{ requestInfo.customerInfo.phone }}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="requestInfo?.technicianName || requestInfo?.technicianId"
      >
        <div class="reports-customer-info">
          <div class="info-title">Technician</div>
          <div class="info-container">
            <div
          class="details-sec"
          *ngIf="requestInfo?.technicianName"
        >
          <div class="sec-header">Name</div>
          <div class="sec-value">
            {{ requestInfo.technicianName }}
          </div>
        </div>
        <div class="details-sec"
          *ngIf="requestInfo?.technicianId"
        >
          <div class="sec-header">ID</div>
          <div class="sec-value">
            {{ requestInfo.technicianId }}
          </div>
        </div>
          </div>
        </div>

      </div>
      <div style="margin-top: 30px" *ngIf="requestInfo?.comments">
        <div class="header-style">
          <div class="header-class">Comments</div>
          <div class="value-font">
            {{ requestInfo.comments }}
          </div>
        </div>
      </div>
      <div style="margin-top: 30px">
        <div class="header-style">
          <div class="header-class">Summary</div>
          <div class="pass-color" *ngIf="overallResult === 'Pass'">TEST PASSED</div>
          <div class="fail-color" *ngIf="overallResult === 'Fail'">
            TEST FAILED
            <div class="fail-color-3" *ngIf="errorMessage">{{ errorMessage }}</div>
          </div>

          <div class="unknown-color" *ngIf="overallResult === 'Inconclusive'">
            TEST INCONCLUSIVE
          </div>
          <div
            class="unknown-color"
            *ngIf="overallResult === 'Unknown' || overallResult === 'unknown'"
          >
            TEST {{ controllerStatus | uppercase }}
            <div class="fail-color-3" *ngIf="errorMessage">{{ errorMessage }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="testConfig && !isPcClientView">
    <!-- Throughput Statistics -->
    <div class="page config-section" *ngIf="throughputTableData">
      <h4>Throughput Statistics</h4>
      <div
        id="throughputChart"
        *ngIf="throughputChartOptions?.series?.length"
        style="width: 100%; height: 400px; margin: 0 auto"
      ></div>
      <span
        class="verdict-msg error-color-hue-1"
        *ngIf="
          throughputTableData[1] &&
          throughputTableData[1][throughputTableData[1].length - 2] === 'fail'
        "
      >
        {{ throughputTableData[1][throughputTableData[1].length - 2] }} -
        {{ throughputTableData[1][throughputTableData[1].length - 1] }}
      </span>
      <div id="strmCfgRegion" class="streams-container" style="overflow-x: auto !important">
        <div class="table-container">
          <table id="streamsTable" class="streams-table">
            <tr
              *ngFor="let tableArr of throughputTableData; let i = index"
              class="table-row-align"
              style="width: 100% !important; margin: 0 auto"
            >
              <ng-container *ngFor="let tableColumnVal of tableArr; let j = index">
                <td *ngIf="j < tableArr.length - 2">
                  {{ tableColumnVal }}
                </td>
              </ng-container>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- Latency Statistics -->
    <div class="page config-section" *ngIf="latencyTableData">
      <h4>Latency Statistics</h4>
      <div
        id="latencyChart"
        *ngIf="latencyChartOptions?.series?.length"
        style="width: 100%; height: 400px; margin: 0 auto"
      ></div>
      <div *ngIf="orginatorModel !== 'MAP-2100'">
        <div
          id="latencyFrameCountChart"
          *ngIf="latencyCountChartOptions?.series?.length"
          style="width: 100%; height: 400px; margin: 0 auto"
        ></div>
      </div>
      <span
        class="verdict-msg error-color-hue-1"
        *ngIf="
          latencyTableData[1] && latencyTableData[1][latencyTableData[1].length - 2] === 'fail'
        "
      >
        {{ latencyTableData[1][latencyTableData[1].length - 2] }} -
        {{ latencyTableData[1][latencyTableData[1].length - 1] }}
      </span>
      <div id="strmCfgRegion" class="streams-container" style="overflow-x: auto !important">
        <table id="streamsTable" class="streams-table">
          <tr *ngFor="let tableArr of latencyTableData; let i = index" class="table-row-align">
            <ng-container *ngFor="let tableColumnVal of tableArr; let j = index">
              <td *ngIf="j < tableArr.length - 2">
                {{ tableColumnVal }}
              </td>
            </ng-container>
          </tr>
        </table>
      </div>
    </div>

    <!-- FDV Results -->
    <div class="page config-section" *ngIf="fdvTableData">
      <h4>FDV Results</h4>
      <div
        id="fdvChart"
        *ngIf="fdvChartOptions?.series?.length"
        style="width: 100%; height: 400px; margin: 0 auto"
      ></div>
      <span
        class="verdict-msg error-color-hue-1"
        *ngIf="fdvTableData[1] && fdvTableData[1][fdvTableData[1].length - 2] === 'fail'"
      >
        {{ fdvTableData[1][fdvTableData[1].length - 2] }} -
        {{ fdvTableData[1][fdvTableData[1].length - 1] }}
      </span>
      <div id="strmCfgRegion" class="streams-container" style="overflow-x: auto !important">
        <table id="streamsTable" class="streams-table">
          <tr *ngFor="let tableArr of fdvTableData; let i = index" class="table-row-align">
            <ng-container *ngFor="let tableColumnVal of tableArr; let j = index">
              <td *ngIf="j < tableArr.length - 2">
                {{ tableColumnVal }}
              </td>
            </ng-container>
          </tr>
        </table>
      </div>
    </div>

    <!-- Frame Loss Statistics -->
    <div class="page config-section" *ngIf="frameLossTableData">
      <h4>Frame Loss Statistics</h4>
      <div
        id="frameLossChart"
        *ngIf="frameLossChartOptions?.series?.length"
        style="width: 100%; height: 400px; margin: 0 auto"
      ></div>
      <span
        class="verdict-msg error-color-hue-1"
        *ngIf="
          frameLossTableData[1] &&
          frameLossTableData[1][frameLossTableData[1].length - 2] === 'fail'
        "
      >
        {{ frameLossTableData[1][frameLossTableData[1].length - 2] }} -
        {{ frameLossTableData[1][frameLossTableData[1].length - 1] }}
      </span>
      <div id="strmCfgRegion" class="streams-container" style="overflow-x: auto !important">
        <table id="streamsTable" class="streams-table">
          <tr *ngFor="let tableArr of frameLossTableData; let i = index" class="table-row-align">
            <ng-container *ngFor="let tableColumnVal of tableArr; let j = index">
              <td *ngIf="j < tableArr.length - 2">
                {{ tableColumnVal }}
              </td>
            </ng-container>
          </tr>
        </table>
      </div>
    </div>

    <!-- Back to Back Statistics -->
    <div class="page config-section" *ngIf="b2bTableData">
      <h4>Back to Back Statistics</h4>
      <span
        class="verdict-msg error-color-hue-1"
        *ngIf="b2bTableData[1] && b2bTableData[1][b2bTableData[1].length - 2] === 'fail'"
      >
        {{ b2bTableData[1][b2bTableData[1].length - 2] }} -
        {{ b2bTableData[1][b2bTableData[1].length - 1] }}
      </span>
      <div id="strmCfgRegion" class="streams-container" style="overflow-x: auto !important">
        <table id="streamsTable" class="streams-table">
          <tr *ngFor="let tableArr of b2bTableData; let i = index" class="table-row-align">
            <ng-container *ngFor="let tableColumnVal of tableArr; let j = index">
              <td *ngIf="j < tableArr.length - 2">
                {{ tableColumnVal }}
              </td>
            </ng-container>
          </tr>
        </table>
      </div>
    </div>

    <!-- Committed Burst Size Statistics -->
    <div class="page config-section" *ngIf="cbsTableData">
      <h4>Committed Burst Size Statistics</h4>
      <div
        id="cbsChart"
        *ngIf="cbsChartOptions?.series?.length"
        style="width: 100%; height: 400px; margin: 0 auto"
      ></div>
      <span
        class="verdict-msg error-color-hue-1"
        *ngIf="cbsTableData[1] && cbsTableData[1][cbsTableData[1].length - 2] === 'fail'"
      >
        {{ cbsTableData[1][cbsTableData[1].length - 2] }} -
        {{ cbsTableData[1][cbsTableData[1].length - 1] }}
      </span>
      <div id="strmCfgRegion" class="streams-container" style="overflow-x: auto !important">
        <table id="streamsTable" class="streams-table">
          <tr *ngFor="let tableArr of cbsTableData; let i = index" class="table-row-align">
            <ng-container *ngFor="let tableColumnVal of tableArr; let j = index">
              <td *ngIf="j < tableArr.length - 2">
                {{ tableColumnVal }}
              </td>
            </ng-container>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div class="page" *ngIf="testConfig">
    <div style="width: 100%">
      <div class="header-font-2">
        <i class="material-icons icon">settings</i>
        <h4 class="test-font">Test Configuration</h4>
      </div>
      <!-- Test Setup -->
      <div class="test-margin">
        <div class="test-font">Test Setup</div>
        <table class="test-setup-table">
          <tr *ngFor="let attr of testConfigDisplay.overall">
            <td class="test-color" style="width: 30% !important">{{ attr.name }}</td>
            <td>{{ attr.value }}</td>
          </tr>
        </table>
      </div>

      <div class="test-margin">
        <div class="test-font">Originator</div>
        <table class="test-setup-table">
          <tr>
            <td class="test-color" style="width: 30% !important">Name</td>
            <td>{{ overallConfiguration.agent.primary.id }}</td>
          </tr>
          <tr *ngFor="let attr of testConfigDisplay.testPoints">
            <td class="test-color" style="width: 30% !important">{{ attr.name }}</td>
            <td>{{ attr.value }}</td>
          </tr>
        </table>
      </div>

      <!-- Destination -->
      <div class="test-margin">
        <div class="test-font">Destination</div>
        <table class="test-setup-table">
          <tr *ngFor="let attr of testConfigDisplay.destination">
            <td class="test-color" style="width: 30% !important">{{ attr.name }}</td>
            <td>{{ attr.value }}</td>
          </tr>
        </table>
      </div>

      <!-- Stream Setup -->
      <div class="test-margin">
        <div class="test-font">Stream Setup</div>
        <table class="test-setup-table">
          <tr *ngFor="let attr of testConfigDisplay.streams">
            <td class="test-color" style="width: 30% !important">{{ attr.name }}</td>
            <td>{{ attr.value }}</td>
          </tr>
        </table>
      </div>

      <!-- Optimization Options -->
      <div class="test-margin">
        <div class="test-font">Optimization Options</div>
        <table class="test-setup-table">
          <tr *ngFor="let attr of testConfigDisplay.Optimization">
            <td class="test-color" style="width: 30% !important">{{ attr.name }}</td>
            <td>{{ attr.value }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div
    fxLayout="column"
    class="page"
    fxLayoutGap="16px"
    *ngIf="reportmessage && reportmessage?.length !== 0"
  >
    <div class="page-break"></div>

    <mat-toolbar class="diagnosis-head border">
      <div class="mat-toolbar-tools">
        <h2 class="mat-flex">Report Message</h2>
      </div>
    </mat-toolbar>

    <mat-card class="border" fxLayout="column" fxLayoutGap="16px">
      <div fxLayout="row">
        <span>{{ reportmessage }}</span>
      </div>
    </mat-card>
  </div>
</div>
<div class="truespeed-content" *ngIf="loading">
  <div class="loader-content">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">Getting Reports</div>
    </div>
  </div>
</div>
